import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from './interviewPaymentStatusTypes'
import API from './interviewPaymentStatusApis'

function* watchFetchInterviewPaymentStatus() {
  try {
    const response = yield call(API.fetchInterviewPaymentStatuses)

    if (response.status === 200) {
      yield put({type: types.FETCH_INTERVIEW_PAYMENT_STATUS_SUCCEEDED, payload: response.data})
    }
  } catch (err) {
    yield put({type: types.FETCH_INTERVIEW_PAYMENT_STATUS_FAILED, err})
  }
}

export default function* () {
  yield takeLatest(types.FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED, watchFetchInterviewPaymentStatus)
}